import { environment } from '@env/environment';

export default {
	portal: {
		api_url: `${environment.baseUrl}/api/`,
		auth_translation: `${environment.baseUrl}/lang/login_page`,
		token_auth: `${environment.baseUrl}/api/token-auth/`,
		password_reset: `${environment.baseUrl}/api/users/password-reset`,
		set_password: `${environment.baseUrl}/api/users/password-set`,
		dashboard_translation: `${environment.baseUrl}/lang/dashboard`,
		chartLicenseKey: 'CH232348490',
		intercomId: 'h7fpqde4',
		pendoApiKey: '488d937e-fe57-4728-7a00-08ce5d2d6d5f',
		aiChatApiKey: 'autility-2608',
		mapboxKey:
			'pk.eyJ1IjoiYW5rZWFuZSIsImEiOiJja2dtMjIwc2cweXJrMnVuYWtvcnZmNmNhIn0.BB6tOA59_L41OkwBB2mNTw',
	},
	auRoutes: {
		login: {
			name: 'login',
			link: 'login',
		},
		organization: {
			name: 'organization',
			link: 'settings/organization',
			children: {
				import: {
					name: 'import',
					link: 'import',
					children: {
						files: {
							name: 'files',
							link: 'files',
						},
					},
				},
			},
		},
		errorPage: {
			name: 'error_page',
			link: 'error_page',
		},
		recoveryPassword: {
			name: 'recovery-password',
			link: 'recovery-password',
		},
		passwordReset: {
			name: 'password-reset',
			link: 'password-reset',
		},
		setPassword: {
			name: 'set password',
			link: 'password-set',
		},
		dashboard: {
			name: 'dashboard',
			link: 'dashboard',
			tabsConfig: {
				buildings: {
					id: 0,
					name: 'buildings',
					link: 'buildings',
					icon: 'portfolio',
				},
				zones: {
					id: 1,
					name: 'zones',
					link: 'zones',
					icon: 'panorama',
				},
				tenants: {
					id: 2,
					name: 'tenants',
					link: 'tenants',
					icon: 'users',
				},
			},
		},
		assets: {
			name: 'assets',
			link: 'all-assets',
			children: {
				buildings: {
					id: 0,
					name: 'buildings',
					link: 'buildings',
					icon: 'building',
					children: {
						roomEdit: {
							name: 'Room Edit',
							link: 'room-edit',
						},
					},
				},
				sensors: {
					id: 1,
					name: 'sensors',
					link: 'sensors',
					icon: 'sensor',
				},
				zones: {
					id: 2,
					name: 'zones',
					link: 'zones',
					icon: 'panorama',
				},
			},
		},
		cmms: {
			name: 'operations',
			link: 'cmms',
			children: {
				workOrders: {
					name: 'work_orders',
					link: 'work-orders',
				},
				incidents: {
					name: 'incidents',
					link: 'incidents',
				},
				requests: {
					name: 'requests',
					link: 'requests',
				},
				files: {
					name: 'files',
					link: 'files',
				},
				assets: {
					name: 'assets',
					link: 'assets',
				},
				messages: {
					name: 'messages',
					link: 'messages',
				},
				contacts: {
					name: 'contacts',
					link: 'contacts',
				},
				createNew: {
					name: 'new_entity',
					link: 'new-entity',
				},
			},
		},
		files: {
			name: 'files',
			link: 'files',
			children: {
				fileImport: {
					name: 'file-import',
					link: 'file-import',
				},
			},
		},

		analytics: {
			name: 'analytics',
			link: 'analytics',
		},
		users: {
			name: 'users',
			link: 'users',

			editProfile: {
				name: 'Edit Profile',
				link: 'profile',
			},
			changePassword: {
				name: 'Change Password',
				link: 'change-password',
			},
		},
		digital_twin: {
			name: 'digital_twin',
			link: 'digital-twin',
		},
		inbox: {
			name: 'inbox_header',
			link: 'inbox',
		},
	},
	local_storage: {
		current_user: 'au-currentuser',
		auth_token: 'au-token',
		settings: 'au-settings',
	},
};
